import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-nav-admin',
    templateUrl: './nav-admin.component.html',
    styleUrls: ['./nav-admin.component.scss']
})
export class NavAdminComponent {
    constructor(
        private router: Router
    ) {}

    goToHome() {
        this.router.navigateByUrl('/home');
    }
}